import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {Params} from '@angular/router';
import {DataResponse} from '../../../network/service/data.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {DetailsOptions, DynamicField} from '../dialog/details/options/details.options';
import {DetailsComponent} from '../dialog/details/details.component';
import {RouteUtil} from '../../../util/route.util';

@Component({
  selector: 'app-add-or-update-domain',
  standalone: false,
  templateUrl: './add-or-update-domain.component.html',
  styleUrls: ['./add-or-update-domain.component.scss']
})
export class AddOrUpdateDomainComponent extends BaseComponent implements OnInit {
  domainId?: string;
  title?: string;
  domainName?: string;
  details?: any;
  businessId?: string;
  domain?: any;

  constructor(injector: Injector) {
    super(injector);
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['DomainId'] && params['DomainId'] !== '') {
        this.domainId = params['DomainId'];
      }
    });
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    if (this.domainId) {
      this.serviceApi.getDomains(this.tableProperties.offset, this.tableProperties.limit, 'Business', RequestType.ONE, {
        Filter: {
          Values: [{
            Field: 'DomainId',
            Type: 'EQ',
            Value: this.domainId
          }]
        }
      }).subscribe((res: ListResponse<any>) => {
        if (res.success) {
          this.domain = res.data;
          this.onDataPrepared();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    }
  }

  onSubmitClicked() {
    const body = {
      Title: this.title,
      DomainName: this.domainName,
      Details: this.details,
      BusinessId: this.businessId
    };
    (this.domainId !== undefined ? this.serviceApi.updateDomains(this.domainId, body) : this.serviceApi.createDomains(body))
      .subscribe((res: DataResponse<any>) => {
        if (res.success) {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.DOMAINS_COMPONENT]).then();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
  }

  onCancelClicked() {
    this.location.back();
  }

  onDetailClicked() {
    const fieldMeta: Record<string, Partial<DynamicField>> = {
      Videos: {
        type: 'file-chooser',
        isMultiple: true
      },
      Favicon: {
        type: 'file-chooser',
        isMultiple: false
      },
      LogoText: {
        type: 'file-chooser',
        isMultiple: false
      },
      FooterColor: {type: 'color'},
      HeaderColor: {type: 'color'},
      AppleFavicon: {
        type: 'file-chooser',
        isMultiple: false
      },
      PrimaryColor: {type: 'color'},
      ManifestFileId: {
        type: 'file-chooser',
        isMultiple: false
      },
      AccentTextColor: {type: 'color'},
      FooterTextColor: {type: 'color'},
      HeaderTextColor: {type: 'color'},
      PrimaryTextColor: {type: 'color'},
      AccentBorderColor: {type: 'color'},
      DiscountedBoxColor: {type: 'color'},
      PrimaryBorderColor: {type: 'color'},
      LogoBackgroundColor: {type: 'color'},
      AccentBackgroundColor: {type: 'color'},
      LogoBackgroundOpacity: {type: 'text'},
      DiscountedBoxTextColor: {type: 'color'},
      PrimaryBackgroundColor: {type: 'color'},
      ContainerId: {type: 'text'}
    };
    const detailsSource = this.details || {};
    const configFields: DynamicField[] = Object.keys(fieldMeta).map(key => {
      const meta = fieldMeta[key] || {};
      let value: any = detailsSource[key] ?? '';
      const type = meta.type || 'text';
      const isMultiple = meta.isMultiple || false;
      const required = meta.required || false;
      const options = meta.options;
      if (type === 'file-chooser' && typeof value === 'string') {
        value = [{name: value}];
      }
      if (type === 'file-chooser' && Array.isArray(value)) {
        value = value.map(v => (typeof v === 'string' ? {name: v} : v));
      }
      return {
        label: key,
        type,
        value,
        required,
        isMultiple,
        options
      } as DynamicField;
    });
    const detailsOptions = new DetailsOptions();
    detailsOptions.fields = configFields;
    detailsOptions.onDetailsSelected = (details: any) => {
      this.details = details;
    };
    const detailsComponent = this.matDialog.open(DetailsComponent, {
      height: 'auto',
      width: '100%',
      direction: 'rtl'
    });
    detailsComponent.componentInstance.detailsOptions = detailsOptions;
    detailsComponent.componentInstance.configData = this.details;
  }

  private onDataPrepared() {
    this.title = this.domain?.Title;
    this.domainName = this.domain?.DomainName;
    this.businessId = this.domain?.BusinessId;
    this.details = this.domain?.Details;
  }
}


